const updates = [
  {
    date: '07-29',
    title: '本周国产新片速递：三部口碑佳作同步上线',
    desc: '《暗夜追凶》《铁血战狼》《云端之上》三大类型影片同日更新，满足不同观众口味。',
  },
  {
    date: '07-28',
    title: '暑期档国产电影热度榜刷新，《星海征途》登顶',
    desc: '科幻巨制持续领跑暑期档，国产电影市场表现强劲，多部新片口碑票房双丰收。',
  },
  {
    date: '07-27',
    title: '国产动画电影再创佳绩，国漫崛起势不可挡',
    desc: '最新国产动画电影上映首周票房突破五亿，精良制作和动人故事赢得观众一致好评。',
  },
  {
    date: '07-26',
    title: '资深影评人推荐：下半年最值得期待的十部国产片',
    desc: '涵盖动作、悬疑、文艺、喜剧等多种类型，下半年国产电影市场精彩纷呈。',
  },
  {
    date: '07-25',
    title: '经典国产老片修复版上线，重温银幕经典',
    desc: '多部上世纪经典国产影片经过4K修复后重新上线，画质焕然一新，唤起时代记忆。',
  },
  {
    date: '07-24',
    title: '国产独立电影在国际电影节斩获多项大奖',
    desc: '新生代导演作品在国际舞台大放异彩，展现中国电影多元化的创作力量。',
  },
  {
    date: '07-23',
    title: '悬疑类型国产片持续走热，观众口碑推动票房',
    desc: '近三个月悬疑类国产影片观影人次同比增长显著，类型片市场日趋成熟。',
  },
  {
    date: '07-22',
    title: '国产纪录片《山河纪行》引发全网热议',
    desc: '以壮丽山河为背景的人文纪录片，用镜头语言讲述中国故事，豆瓣评分高达9.2。',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
            最新动态
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            国产电影圈每日新鲜事，不错过任何精彩
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-0">
          {updates.map((item, idx) => (
            <div
              key={idx}
              className="flex gap-4 md:gap-5 py-4 md:py-5 border-b border-background-200/70 last:border-b-0"
            >
              <div className="flex-shrink-0 w-14 md:w-16 text-center">
                <div className="text-xs text-foreground-500 font-medium">{item.date}</div>
                <div className="mt-0.5 w-2 h-2 rounded-full bg-primary-500 mx-auto"></div>
              </div>
              <div>
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}